/* eslint-disable react/jsx-key */
import React from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import ReplenishDepositImage from '@/assets/images/ReplenishDepositImage.svg';
import { BigTitle } from '@/components';

import RevealingContainer from '../revealing-container';

function LandingInvestReplenish() {
  const { t } = useTranslation();
  const location = window.location.host;

  const containerInfo = [
    {
      title: t('deposit.deposit_replenish.container_1.title'),
      caption: t('deposit.deposit_replenish.container_1.caption'),
      info: [
        t('deposit.deposit_replenish.container_1.p1'),
        t('deposit.deposit_replenish.container_1.p2'),
        t('deposit.deposit_replenish.container_1.p3'),
        t('deposit.deposit_replenish.container_1.p4')
      ]
    },
    {
      title: t('deposit.deposit_replenish.container_2.title'),
      caption: t('deposit.deposit_replenish.container_2.caption'),
      info: [
        t('deposit.deposit_replenish.container_2.p1'),
        t('deposit.deposit_replenish.container_2.p2'),
        <span>
          Лимиты на переводы с карт Mastercard: на один перевод — 5 000 $, сумма всех переводов за сутки — 20 000 $, за
          неделю — 50 000 $, за месяц — 100 000 $ (эквивалент в валюте перевода).
        </span>,
        t('deposit.deposit_replenish.container_2.p4')
      ]
    },
    // {
    //   title: t('deposit_replenish.container_3.title'),
    //   caption: t('deposit_replenish.container_3.caption'),
    //   info: [
    //     <span>
    //       Для перевода денег с карт МИР на карту Фридом Банка воспользуйтесь сервисом
    //       <a tw='underline cursor-pointer' href='https://moneysend.money' target='_blank' rel='noreferrer'>
    //         {' '}
    //         Moneysend.
    //       </a>
    //     </span>,
    //     t('deposit_replenish.container_3.p2'),
    //     <span>
    //       У нас нет комиссий на пополнение с карт. Но комиссии и ограничения могут быть у банка, выпустившего карту
    //       отправителя.
    //     </span>
    //   ]
    // },
    // {
    //   title: t('deposit_replenish.container_4.title'),
    //   caption: t('deposit_replenish.container_4.caption'),
    //   info: [
    //     <span>
    //       В мобильном приложении Цифра Банка переведите деньги по номеру телефона на свою карту или счёт, открытые в
    //       Казахстане.{' '}
    //       <a
    //         tw='underline cursor-pointer'
    //         href={`${
    //           import.meta.env.DEV
    //             ? location === 'non-resident.trafficwave.kz'
    //               ? import.meta.env.NRDEV_MEDIA
    //               : import.meta.env.NRDEV_MEDIA_WORLD
    //             : location === 'resident.bankffin.kz'
    //             ? import.meta.env.NRPROD_MEDIA
    //             : import.meta.env.NRPROD_MEDIA_WORLD
    //         }/Инструкция_по_отправке_переводов_Цифра_банк_РФ.pdf`}
    //         target={'_blank'}
    //         rel='noreferrer'
    //       >
    //         Подробная инструкция.
    //       </a>
    //     </span>,
    //     t('deposit_replenish.container_4.p2'),
    //     t('deposit_replenish.container_4.p3'),
    //     <span>
    //       Заказать карту Цифра Банка можно{' '}
    //       <a tw='underline cursor-pointer' href=' https://cifra-bank.ru/service-packages/' target='_blank'>
    //         онлайн
    //       </a>{' '}
    //       или{' '}
    //       <a tw='underline cursor-pointer' href=' https://cifra-bank.ru/offices-and-atms/' target='_blank'>
    //         в отделениях на территории РФ
    //       </a>
    //       , пополнить — через систему быстрых переводов из любого банка РФ.
    //     </span>
    //   ]
    // },
    {
      title: t('deposit.deposit_replenish.container_5.title'),
      caption: t('deposit.deposit_replenish.container_5.caption'),
      info: [
        <span>
          Пополняйте счета в{' '}
          <a tw='underline cursor-pointer' target='_blank' href='https://bankffin.kz/ru/branches' rel='noreferrer'>
            банкоматах и отделениях Freedom Bank
          </a>{' '}
          и{' '}
          <a tw='underline cursor-pointer' target='_blank' href='https://fmobile.kz/stores' rel='noreferrer'>
            кассах Freedom Mobile
          </a>{' '}
          на территории Казахстана.
        </span>,
        t('deposit.deposit_replenish.container_5.p2'),
        t('deposit.deposit_replenish.container_5.p3'),
        t('deposit.deposit_replenish.container_5.p4'),
        t('deposit.deposit_replenish.container_5.p5')
      ]
    }
  ];

  return (
    <div>
      <BigTitle
        text={'Удобно пополнять карту'}
        twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] sm:mb-20 mb-10`}
      />
      <div tw='flex sm:flex-row flex-col items-center  w-full gap-10 sm:items-start'>
        <img src={ReplenishDepositImage} alt='' tw='sm:max-w-[400px] max-w-[250px]' />
        <div tw='flex flex-col gap-3 w-full'>
          {containerInfo.map(item => (
            <RevealingContainer cardInfo={item} key={item.title} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default LandingInvestReplenish;
